(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/button/secondary.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/button/secondary.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.payfooter.button = svs.tur.payfooter.button || {};
svs.tur.payfooter.button.CANCEL = 'Avbryt';
class Secondary extends svs.tur.payfooter.button.Default {
  constructor(_ref) {
    let _ref$title = _ref.title,
      title = _ref$title === void 0 ? svs.tur.payfooter.button.CANCEL : _ref$title,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? true : _ref$transparent,
      _ref$outline = _ref.outline,
      outline = _ref$outline === void 0 ? true : _ref$outline,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      callback = _ref.callback,
      id = _ref.id;
    super({
      title,
      callback,
      id,
      transparent,
      inverted: !transparent,
      outline,
      visible
    });
    this.log = new svs.core.log.Logger('payfooter:button:secondary');
  }
}
svs.tur.payfooter.button.Secondary = Secondary;

 })(window);